import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-register-button',
  templateUrl: './register-button.component.html',
  styleUrls: ['./register-button.component.scss'],
})
export class RegisterButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
